package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
internal data class UpdateEmailClientRequestInfo(val email: String)
